import React from "react";
import { useTranslation } from "react-i18next";

import { AvatarSize, AvatarStyle } from "../../enums";
import TestIds from "../../testIds";
import { Image, StyledAvatar } from "./Avatar.styles";
import { SystemAvatarDefs } from "./SystemAvatarDef";

interface IProps {
    src: string;
    title?: string;
    id?: string;
    onClick?: (id: string) => void;
    size: AvatarSize | string;
    transparent?: boolean;
    isRound?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

const Avatar: React.FunctionComponent<IProps> = React.memo(({
                                                                src,
                                                                title,
                                                                id,
                                                                onClick,
                                                                size,
                                                                transparent,
                                                                isRound,
                                                                className,
                                                                style,
                                                                children
                                                            }) => {
    const { t } = useTranslation("Components");

    function handleOnClick(): void {
        onClick?.(id);
    }

    function getFileId(): number {
        const parts = src.split("/");
        return Number(parts[parts.length - 1]);
    }

    function isSystemAvatar(): boolean {
        return getFileId() < 0;
    }

    function getBackgroundStyle(): AvatarStyle {
        if (isSystemAvatar()) {
            return SystemAvatarDefs[getFileId()]?.style || AvatarStyle.None;
        }
        return AvatarStyle.None;
    }

    return (
            <StyledAvatar $size={size}
                          $transparent={transparent || !isSystemAvatar()}
                          $isRound={isRound}
                          className={className} style={style}
                          onClick={handleOnClick}
                          $backgroundStyle={getBackgroundStyle()}
                          data-testid={TestIds.CompanyAvatar}>
                <Image src={src}
                       alt={t("Components:Avatar.AlternativeText")}
                       title={title}
                />
                {children}
            </StyledAvatar>
    );
});

export default Avatar;